import { Action, createReducer, on } from "@ngrx/store";
import * as ControllerActions from "./controller.actions";

export const controllerFeatureKey = 'controller';

export interface Controller {
  uuid: String;
  name: String;
}

export interface Motor {
  uuid: String;
  name: String;
}
export interface PumpEnd {
  uuid: String;
  name: String;
}
export interface ControllerState {
  controller: Controller;
  motor: Motor;
  pumpEnd: PumpEnd;
  partsList: String;
}

export const initialState: ControllerState = {
  controller: {uuid:'', name: ''},
  motor: {uuid:'', name: ''},
  pumpEnd: {uuid:'', name: ''},
  partsList: ''
}

const reducer = createReducer(
  initialState,
  on(ControllerActions.setControlllerName, (state, action) => {
    return {
      ...state,
      controller: action.data
    }
  }),
  on(ControllerActions.setPumpEndName, (state, action) => {
    return {
      ...state,
      pumpEnd: action.data
    }
  }),
  on(ControllerActions.setMotorName, (state, action) => {
    return {
      ...state,
      motor: action.data
    }
  }),
  on(ControllerActions.setPartsListName, (state, action) => {
    return {
      ...state,
      partsList: action.data
    }
  })
);

export function controllerReducer(
  state: ControllerState,
  action: Action
): ControllerState {
  return reducer(state, action);
}
